import { Component, input, Input, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/api.service';

@Component({
  selector: 'app-invoice-download-button',
  templateUrl: './invoice-download-button.component.html',
  styleUrls: ['./invoice-download-button.component.scss']
})
export class InvoiceDownloadButtonComponent implements OnInit {
    @Input() orgId: any;
    @Input() invoiceId: number;
    @Input() showText=false;

    constructor(private api: ApiService) { }

    ngOnInit(): void {
    }

    downloadInvoice(){
        this.api.downloadInvoice(this.invoiceId, this.orgId).subscribe();
    }

}
